import React, { memo } from 'react';
import { useModalState } from 'hooks';
import { CbmModal as Modal, List, ListItem, Text } from '@groupelacentrale/contact-storybook';
import { IconInfo } from '@groupelacentrale/contact-storybook/lib/icons';
import { VehicleConditionLabels } from 'utils/vehicleCondition';

export const VehicleConditionModal: React.FC = memo(() => {
  const { isOpen, open, close } = useModalState();
  return (
    <>
      <span className="vehicle-condition-icon">
        <IconInfo width={16} onClick={open} />
      </span>
      <Modal title="État du véhicule" isOpen={isOpen} onClose={close} showCloseButton size="medium">
        <List>
          {VehicleConditionLabels.map(condition => (
            <ListItem key={condition.label}>
              <Text size="medium" weight="bold">
                {condition.label}
              </Text>
              <Text>{condition.decription}</Text>
            </ListItem>
          ))}
        </List>
      </Modal>
    </>
  );
});

VehicleConditionModal.displayName = 'VehicleConditionModal';
